module.exports = __webpack_public_path__ + "img/1557812495.f7673c09.jpg";